import React, {
  Fragment,
} from 'react';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Fab from '@material-ui/core/Fab';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import { setData } from '../../../actions/index';
import confirm from '../../shared/ConfirmDialog';
import FileAttachmentRow from "../FileAttachmentRow";
import FileAttachmentDownloadDialog from "../../shared/FileAttachmentDownloadDialog";

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
  loader: {
    marginLeft: 10,
  },
  content: {
    padding: isMobileApp
      ? 20
      : '80px 80px 20px',
    margin: '10px auto',
    width: '100%',
    textAlign: 'left',
    color: '#222222',
    boxSizing: 'border-box',
  },
  formGroup: {
    marginBottom: 30,
  },
  breakWord: {
    wordWrap: 'break-word',
  },
  closeButtonIcon: {
    float: 'right',
    marginBottom: -7,
  },
  uploadAttachmentIcon: {
    marginRight: 10,
  },
  helpText: {
    backgroundColor: '#fafafa',
    padding: 15,
    fontSize: 14,
    marginBottom: 30,
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
    selectedPupil: state.selectedPupil,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class AbsencesDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      draftId: null,
      date: null,
      reason: '',
      attachments: [],
      isAttachmentUploading: false,
      attachedFileName: null,
      submitting: false,
    };

    this.attachmentInput = React.createRef();
    this.axiosCancel = null;

    this.onDateChange = this.onDateChange.bind(this);
    this.onReasonChange = this.onReasonChange.bind(this);
    this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
    this.onAttachmentChange = this.onAttachmentChange.bind(this);
    this.onAttachmentButtonClick = this.onAttachmentButtonClick.bind(this);
    this.onAttachmentRemoveButtonClick = this.onAttachmentRemoveButtonClick.bind(this);
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.data &&
      this.props.data !== prevProps.data
    ) {
      this.setState({
        draftId: this.props.data.id,
        date: moment(this.props.data.date_absent).toDate(),
        reason: this.props.data.reason,
        attachments: this.props.data.attachments,
        isAttachmentUploading: false,
        submitting: false,
      });
    } else if (this.props.isDialogOpen !== prevProps.isDialogOpen) {
      this.setState({
        draftId: null,
        date: null,
        reason: '',
        attachments: [],
        isAttachmentUploading: false,
        submitting: false,
      });
    }
  }

  onDateChange(date) {
    this.setState({
      date,
    });
  }

  onReasonChange(event) {
    this.setState({
      reason: event.target.value,
    });
  }

  onSubmitButtonClick() {
    const {
      t,
      selectedPupil,
      onDialogClose,
      reloadData,
      enqueueSnackbar,
      data,
    } = this.props;
    const {
      reason,
      date,
      draftId,
    } = this.state;

    let url = `${window.apiReportAbsenceUrl}/reportabsence`;
    let params = {
      pupil_id: selectedPupil.id,
      date_absent: moment(date).format('YYYY-MM-DD'),
      reason,
    };

    if (draftId) {
      params.draft_id = draftId;
    }

    if (data) {
      url = `${window.apiReportAbsenceUrl}/editreportedabsence/${data.id}`;
    }

    this.setState({
      submitting: true,
    });

    return axios
      .post(
        url,
        qs.stringify(params),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      ).then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(t('You have successfully saved the absence'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.setState({
            draftId: null,
            date: new Date(),
            reason: '',
          });

          onDialogClose();
          reloadData();
        }

        this.setState({
          submitting: false,
        });
      }).catch(() => {
        this.setState({
          submitting: false,
        });
      })
    ;
  }

  onAttachmentChange(event) {
    const {
      t,
      selectedPupil,
      enqueueSnackbar,
    } = this.props;
    const {
      draftId,
    } = this.state;

    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const data = new FormData();
    data.append('file', file);
    data.append('pupil_id', selectedPupil.id);
    if (draftId) {
      data.append('reported_absence_id', draftId);
    }

    this.setState({
      isAttachmentUploading: true,
      attachedFileName: file.name,
    });

    axios
      .post(
        `${window.apiReportAbsenceUrl}/uploadreportedabsenceevidence`,
        data,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 3000,
          });
        } else {
          enqueueSnackbar(t('You have successfully uploaded the attachment.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          const newData = response.data.data;

          this.setState({
            draftId: newData.id,
            attachments: newData.attachments,
            attachedFileName: null,
          });
        }

        if (this.attachmentInput.current) {
          this.attachmentInput.current.value = null;
        }

        this.setState({
          isAttachmentUploading: false,
        });

        if (this.props.data) {
          this.props.reloadData();
        }
      })
      .catch((thrown) => {});
  }

  onAttachmentButtonClick() {
    this.attachmentInput.current?.click();
  }

  onAttachmentRemoveButtonClick(attachmentId, event) {
    const {
      t,
      enqueueSnackbar,
    } = this.props;
    const {
      draftId,
      attachments,
    } = this.state;

    event.preventDefault();

    confirm('Are you sure you wish to remove this attachment?').then(
      () => {
        axios
          .post(
            `${window.apiReportAbsenceUrl}/deleteeportedabsenceevidence`,
            qs.stringify({
              reported_absence_id: draftId,
              reported_absence_attachment_id: attachmentId,
            }),
            {
              cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
            }
          ).then((response) => {
            if (response.data.error) {
              enqueueSnackbar(response.data.error, {
                variant: 'error',
                autoHideDuration: 2000,
              });
            } else {
              enqueueSnackbar(t('You have successfully deleted the attachment'), {
                variant: 'success',
                autoHideDuration: 2000,
              });

              const remainingAttachments = attachments.filter((attachment) => {
                return attachment.reported_absence_attachment_id !== attachmentId;
              });

              this.setState({
                attachments: remainingAttachments,
              });

              if (remainingAttachments === 0) {
                this.setState({
                  draftId: null,
                });
              }
            }
          }).catch((thrown) => {});
      },
      () => {
        // Nothing to do
      }
    );
  }

  /**
   * TODO convert this to component
   * @param attachment
   * @param event
   */
  onDownloadDialogOpen(attachment, event) {
    if (attachment.scan_status === 'pass') {
      return true;
    }

    event.preventDefault();

    FileAttachmentDownloadDialog(null, {
      scan_status: attachment.scan_status,
      scan_status_message: attachment.scan_status_message
    });
  }

  render() {
    const {
      date,
      reason,
      attachments,
      attachedFileName,
      isAttachmentUploading,
      submitting,
    } = this.state;
    const {
      classes,
      t,
      isDialogOpen,
      onDialogClose,
      meta,
      selectedPupil,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        className="absences-dialog"
      >
        <IconButton
          aria-label="Close"
          onClick={onDialogClose}
          className={`absences-dialog-close-button ${classes.closeIcon}`}
        >
          <CloseIcon />
        </IconButton>
        <div className={classes.content}>
          <div className={classes.formGroup}>
            <KeyboardDatePicker
              clearable
              disableToolbar
              format={dateFormat}
              id="date-picker"
              label={t('Date of absence')}
              value={date}
              onChange={this.onDateChange}
            />
          </div>
          {date && (
            <div className={classes.helpText}>
              {t('You are submitting an absence for {pupil_first_name} for {date}')
              .replace('{pupil_first_name}', selectedPupil.first_name)
              .replace('{date}', moment(date).format('dddd Do of MMMM YYYY'))}
            </div>
          )}
          <div className={classes.formGroup}>
            <TextField
              autoFocus
              fullWidth
              multiline
              rows="6"
              label={t('Reason for absence')}
              value={reason}
              onChange={this.onReasonChange}
            />
          </div>
          {meta?.help_text && (
            <div className={classes.helpText}>
              {meta.help_text}
            </div>
          )}
          <Typography
            className={classes.contentTitle}
            variant="h6"
            component="h6"
          >
            {t('Attachments')}
          </Typography>
          <List className={classes.breakWord}>
            {attachments.map((attachment) => {
              let link = attachment.url;
              if (link && typeof isIosApp !== 'undefined' && isIosApp) {
                const sep = link.match(/\?/) ? '&' : '?';
                link = link + sep + 'delayed=yes';
              }

              const primary = (
                <Fragment>
                  <FileAttachmentRow attachment={attachment} />
                  <DeleteIcon
                    className={classes.closeButtonIcon}
                    onClick={this.onAttachmentRemoveButtonClick.bind(this, attachment.reported_absence_attachment_id)}
                  />
                </Fragment>
              );

              return (
                <ListItem
                  key={attachment.reported_absence_attachment_id}
                  button
                  component="a"
                  href={link}
                  target={typeof isIosApp !== 'undefined' && isIosApp ? '_system' : '_blank'}
                  onClick={this.onDownloadDialogOpen.bind(this, attachment)}
                >
                  <ListItemText primary={primary} />
                </ListItem>
              );
            })}
          </List>
          <Fab
            size="small"
            variant="extended"
            color="secondary"
            onClick={this.onAttachmentButtonClick}
          >
            <AddIcon className={classes.uploadAttachmentIcon} />
            {isAttachmentUploading && attachedFileName && (
              <span>
                {t('Uploading')}
                {' '}
                {attachedFileName}
              </span>
            )}
            {isAttachmentUploading && (
              <CircularProgress
                className={classes.loader}
                size={20}
              />
            )}
            {!isAttachmentUploading && (
              <span>{t('Attach supporting evidence')}</span>
            )}
          </Fab>
          <p>
            {t('A maximum of {{maxFilesAllowed}} attachments can be uploaded, each up to {{maxFilesizeAllowed}} in size.', {
              maxFilesAllowed: meta?.max_files_allowed,
              maxFilesizeAllowed: meta?.max_filesize_allowed,
            })}
          </p>
          {meta?.allowed_file_types && (
            <p>
              <span>{t('Supported file formats')}: </span>
              {meta.allowed_file_types.join(', ')}
            </p>
          )}
          <input
            ref={this.attachmentInput}
            type="file"
            style={{ display: 'none' }}
            onChange={this.onAttachmentChange}
          />
        </div>
        <DialogActions>
          <Button
            onClick={this.onSubmitButtonClick}
            color="primary"
            disabled={submitting}
            className="absences-dialog-submit-button"
          >
            {submitting && (
              <>
                <CircularProgress className={classes.loader} size={16} />
                {t('Submitting ...')}
              </>
            )}
            {!submitting && t('Submit')}
          </Button>
          <Button
            onClick={onDialogClose}
            className="absences-dialog-cancel-button"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(AbsencesDialog)))
);
